import { get } from '@lumapps/constants';
import { doesBlobExist, getBlob } from '@lumapps/lumx-images/components/BlobThumbnail/store';

import { DEFAULT_AVATAR } from '../constants';
import { User } from '../types';

const { isWebComponentsApp } = get();

/**
 * Get the avatar of a user based on the userId and customerId.
 *
 * @deprecated You should not this function directly, use the components `UserAvatar`, `Userblock` or `UserLink` instead.
 * @param  {string} userId The identifier of the user to get the avatar of.
 * @param  {string} customerId The identifier of the user to get the avatar of.
 * @return {string} The url to the profile picture of a given user or the default avatar if one of the param is null
 */
export function getAvatarUrl(userId?: string, customerId?: string) {
    if (userId && customerId) {
        const avatarUrl = `/serve/profilepicture/${customerId}/${userId}`;

        // In web components, we need to provide the full URL for the avatar since the relative URL will not work
        if (isWebComponentsApp) {
            return `https://${window.LumappsContext.tenantUrl.split('/')[2]}${avatarUrl}`;
        }

        return avatarUrl;
    }

    return DEFAULT_AVATAR;
}

/**
 * Gets the avatar of a user.
 * @deprecated You should not this function directly, use the components `UserAvatar`, `UserBlock` or `UserLink` instead.
 * @param user
 * @returns {string} The url to the profile picture of a given user or the default avatar if one of the param is null
 */
export const getUserProfilePictureUrl = (
    user: Pick<Partial<User>, 'id' | 'customer'>,
    blobEntry?: string | undefined,
): string => {
    if (blobEntry && doesBlobExist(blobEntry)) {
        return getBlob(blobEntry);
    }

    // eslint-disable-next-line deprecation/deprecation
    return getAvatarUrl(user.id, user.customer);
};
